import {mapGetters} from 'vuex'
import {nanoid} from 'nanoid'
import cloneDeep from 'lodash/cloneDeep'

export default {
  data() {
    return {
      tableLoading: true,
      totalCount: 0,
      page: 1,
      page_size: 20,
      tableNanoid: '',
      vheight: window.innerHeight - 280,
      tableReqMethods: 'post'
    }
  },
  computed: {
    ...mapGetters(['sidebar']),
    isPC() {
      return this.$store.state.app.isPC
    }
  },
  mounted() {
    window.addEventListener('resize', this.refreshTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.refreshTableHeight)
  },
  methods: {
    async init() {
      Object.keys(this.searchForm).map(key => {
        if (this.searchForm[key] === '') {
          this.searchForm[key] = undefined
        }
      })
      this.tableLoading = true
      const api = this.tableUrl
      const {code, data} = await this.$fetch(api, {
        pageNum: this.page,
        pageSize: this.page_size,
        ...this.searchForm
      }, this.tableReqMethods)
      const searchForm = cloneDeep(this.searchForm)
      let list = []
      let totalCount = 0
      this.tableLoading = false
      if (this.tableData && code === 20000) {
        if (Array.isArray(data.data)) {
          list = data.data
        } else if (Array.isArray(data.list)) {
          list = data.list
        } else if (Array.isArray(data)) {
          list = data
        }
        totalCount = Number(data.total)
      }
      this.tableData = [].concat(...list)
      this.totalCount = totalCount
      this.initCallBack && this.initCallBack(code, data, searchForm)
      this.tableNanoid = nanoid()
      this.refreshTableHeight()
    },
    handleCurrentChange(page) {
      this.page = page
      this.init()
    },
    handleSizeChange(page_size) {
      this.page_size = page_size
      this.handleCurrentChange(1)
    },
    // 序号
    indexMethod(index) {
      const page = this.page // 单前页码，具体看组件取值
      const limit = this.page_size // 每页条数，具体是组件取值
      return index + 1 + (page - 1) * limit
    },
    async searchSubmit() {
      this.page = 1
      await this.init()
    },
    searchReset(obj = {}) {
      Object.keys(this.searchForm).forEach(item => {
        this.searchForm[item] = undefined
      })
      Object.keys(obj).filter(item => item !== 'isTrusted').forEach(item => {
        this.searchForm[item] = obj[item]
      })
      this.searchSubmit()
    },
    async refreshTableHeight() {
      if (!this.$refs.elTableRef) {
        return
      }

      try {
        // 52: pagination-box 的高度
        // 20: pagination-box 的 paddingTop + paddingBottom
        // 10: 页面距离底部 10px
        this.vheight = window.innerHeight - this.$refs.elTableRef.$el.getBoundingClientRect().top - (Math.ceil(this.totalCount / this.page_size) > 1 ? 52 : 20) - 10
      } catch (err) {
      }
    },
    rowStyle() {
      return {}
    },
    headerCellStyle() {
      return {
        fontSize: '14px',
        fontWeight: 'bolder',
        backgroundColor: '#EFF3F8',
        color: '#2F2F2F',
        textAlign: 'center'
      }
    }
  },
  watch: {
    'sidebar.opened': function () {
      this.$nextTick(() => {
        // 设置延时300ms的原因：左侧菜单栏切换动画执行耗时0.28s
        const timer = setTimeout(() => {
          clearTimeout(timer)
          this.refreshTableHeight()
        }, 300)
      })
    }
  }
}
